<template>
  <v-layout>
    <v-flex v-if="logo">
      <img
        :src="logo"
        style="width: 100px; margin: 10px;"
        @click="go('/empresa')">
    </v-flex>
    <v-flex xs12>
      <h3>
        <a
          style="color: #000"
          @click="go('/empresa')">{{ empresa.nome }}</a>
      </h3>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    empresa: Object
  },
  data: () => ({
    logo: null
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas']),
    Cargos () {
      let cargos = [
        { 'nome': this.strings[this.idioma]['empresa_gestor'], 'nivel': 0, 'id': 'empresa_gestor' },
        { 'nome': this.strings[this.idioma]['empresa_gerente_regional'], 'nivel': 1, 'id': 'empresa_gerente_regional' },
        { 'nome': this.strings[this.idioma]['empresa_tecnico_venda'], 'nivel': 2, 'id': 'empresa_tecnico_venda' },
        { 'nome': this.strings[this.idioma]['empresa_produtor_vinculado'], 'nivel': 3, 'id': 'empresa_produtor_vinculado' }
      ]
      if (this.user.emp_user && this.user.emp_user.acesso > 0 && this.user.permissao !== 0) {
        cargos = cargos.filter(c => c.nivel > this.user.emp_user.acesso)
      }
      return cargos
    }
  },
  created () {
    this.getLogo()
  },
  methods: {
    getLogo () {
      this.axios.post('empresa/getLogo', { id: this.empresa.id }).then(res => {
        this.logo = res.data.data
      })
      return this.logo
    },
    go (url) {
      window.location.href = url
    },
    mudarEmpresa () {
      sessionStorage.removeItem('empresaAdm')
      this.go('/empresa')
    }
  }
}
</script>
